import(/* webpackMode: "eager" */ "/vercel/path0/app/(marketing)/cookie-policy/page.tsx");
